var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchResultArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3577 0H4.65032C1.73687 0 0 1.736 0 4.648V11.344C0 14.264 1.73687 16 4.65032 16H11.3497C14.2631 16 16 14.264 16 11.352V4.648C16.008 1.736 14.2711 0 11.3577 0ZM12.2061 8.264C12.2061 8.592 11.9339 8.864 11.6058 8.864C11.2776 8.864 11.0055 8.592 11.0055 8.264V5.848L4.8264 12.024C4.70634 12.144 4.55427 12.2 4.40219 12.2C4.25012 12.2 4.09804 12.144 3.97798 12.024C3.74587 11.792 3.74587 11.408 3.97798 11.176L10.1571 5H7.73986C7.41169 5 7.13956 4.728 7.13956 4.4C7.13956 4.072 7.41169 3.8 7.73986 3.8H11.6058C11.9339 3.8 12.2061 4.072 12.2061 4.4V8.264Z",
    fill: "#006633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchResultArrow);
export default __webpack_public_path__ + "static/media/search-result-arrow.8e95e842c587104667c62aa13bc8e944.svg";
export { ForwardRef as ReactComponent };